var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardSettingAlertsettingCustomalertOperateEditIconNormal = function SvgNewcsDashboardSettingAlertsettingCustomalertOperateEditIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_setting_alertsetting_customalert_operate_edit_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152 267h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 560"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_setting_alertsetting_customalert_operate_edit_icon_normal_svg__a)",
    transform: "translate(-152 -267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M152.757 280.942a.75.75 0 0 1-.75-.751V276.3a.75.75 0 0 1 .221-.532l6.242-6.194a.75.75 0 0 1 .528-.217.75.75 0 0 1 .532.221l3.9 3.923a.75.75 0 0 1 0 1.059l-6.16 6.16a.75.75 0 0 1-.53.221Zm.75-4.329v2.829h2.921l5.412-5.412-2.843-2.862Zm11.215-4.388-3.927-3.926a.75.75 0 0 1 0-1.061.75.75 0 0 1 1.061 0l3.926 3.927a.75.75 0 0 1 0 1.06.75.75 0 0 1-.53.22.74.74 0 0 1-.531-.221Z",
    "data-name": "\\u8054\\u5408 73"
  }))));
};
export default SvgNewcsDashboardSettingAlertsettingCustomalertOperateEditIconNormal;